import type { Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauInconnuState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.INCONNU;
		this.state = BordereauStateType.INCONNU;
		this.color = '#000';
		this.libelle = 'Inconnu';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [];
	}

	getMouvementActions(): BaseLiquidationAction<
		Mouvement,
		MouvementActionType
	>[] {
		return [];
	}
}

export default BordereauInconnuState;
